var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.1894C18 9.5985 17.947 9.03032 17.8485 8.48486H10V11.7083H14.4848C14.2917 12.75 13.7045 13.6326 12.822 14.2235V16.3144H15.5152C17.0909 14.8637 18 12.7273 18 10.1894Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9997 18.3335C12.2497 18.3335 14.1361 17.5873 15.5149 16.3146L12.8217 14.2236C12.0755 14.7236 11.1209 15.0191 9.9997 15.0191C7.82925 15.0191 5.99213 13.5532 5.33683 11.5835H2.55273V13.7426C3.92395 16.4661 6.74213 18.3335 9.9997 18.3335Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33696 11.5833C5.17029 11.0833 5.07559 10.5492 5.07559 9.99999C5.07559 9.45075 5.17029 8.91666 5.33696 8.41666V6.25757H2.55287C1.98847 7.38257 1.6665 8.6553 1.6665 9.99999C1.6665 11.3447 1.98847 12.6174 2.55287 13.7424L5.33696 11.5833Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9997 4.98114C11.2232 4.98114 12.3217 5.4016 13.1853 6.22735L15.5755 3.8372C14.1323 2.49251 12.2459 1.66675 9.9997 1.66675C6.74213 1.66675 3.92395 3.53417 2.55273 6.25766L5.33683 8.41675C5.99213 6.44705 7.82925 4.98114 9.9997 4.98114Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c0fdbbe7.svg";
export { ForwardRef as ReactComponent };